import Vue from "vue";
import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$orderProducts = new Vue({
  data() {
    return {
      ecommerceProducts: [],
      ecommerceProductsLoading: false,
      marketplaceProducts: [],
      marketplaceProductsLoading: false,
      ENDPOINTS,
      filter_ecommerce: {
        descricao: "",
        loja: null,
        categoria: "",
      },
      filter_marketplace: {
        descricao: "",
        categoria: "",
        loja: "",
      },
      loading_order: false,
    };
  },
  methods: {
    getStorePayload() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.getLocal("orderProductsEcommerce_store")?.data;
      else return this.$axios.getLocal("oe_user_info")?.data?.loja;
    },

    getProdutos() {
      this.ecommerceProductsLoading = true;
      let filtros = [];
      if (this.filter_ecommerce.descricao != "") {
        filtros.push({
          campo: "prod.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter_ecommerce.descricao,
        });
      }

      if (this.filter_ecommerce.categoria != "") {
        filtros.push({
          campo: "prod.idcategoria",
          tipo: "string",
          valor: this.filter_ecommerce.categoria,
        });
      }

      this.$axios
        .post(this.ENDPOINTS.LISTAR_PRODUTO, {
          loja: this.getStorePayload(),
          filtros,
          lang: "pt",
        })
        .then(response => {
          const dados = response;
          this.ecommerceProducts = dados.filter(
            item => item.status === "ATIVO"
          );
        })
        .catch(error => {
          this.ecommerceProductsLoading = false;
          this.loading_order = false;
          throw new Error(error);
        })
        .finally(() => {
          this.ecommerceProductsLoading = false;
          this.loading_order = false;
        });
    },
    getProductsMarketplace() {
      this.marketplaceProductsLoading = true;
      const dados = {
        listagem_mktp: true,
        filtros: [],
        lang: "pt",
      };

      if (this.filter_marketplace.descricao != "") {
        dados.filtros.push({
          campo: "prod.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter_marketplace.descricao,
        });
      }

      if (this.filter_marketplace.categoria != "") {
        dados.filtros.push({
          campo: "prod.idcategoria",
          tipo: "string",
          valor: this.filter_marketplace.categoria,
        });
      }

      this.$axios
        .post(this.ENDPOINTS.LISTAR_PRODUTO, dados)
        .then(response => {
          const dados = response;
          this.marketplaceProducts = dados.filter(
            item => item.status === "ATIVO"
          );
          this.marketplaceProductsLoading = false;
        })
        .catch(error => {
          this.marketplaceProductsLoading = false;
          this.loading_order = false;
          throw new Error(error);
        })
        .finally(() => {
          this.marketplaceProductsLoading = false;
          this.loading_order = false;
        });
    },

    orderProductsEcommerce(idproduto, ordem) {
      this.loading_order = true;
      const dados = {
        tipo: "wl",
        loja: this.getStorePayload(),
        idproduto,
        ordem,
      };
      this.$axios
        .post(this.ENDPOINTS.ORDENAR_PRODUTO, dados)
        .catch(error => {
          this.loading_order = false;
          throw new Error(error);
        })
        .finally(() => {
          this.getProdutos();
        });
    },
    orderProductsMarketplace(idproduto, ordem, loja) {
      this.loading_order = true;
      const dados = {
        tipo: "mktp",
        loja,
        idproduto,
        ordem,
      };
      this.$axios
        .post(this.ENDPOINTS.ORDENAR_PRODUTO, dados)
        .catch(error => {
          this.loading_order = false;
          throw new Error(error);
        })
        .finally(() => {
          this.getProductsMarketplace();
        });
    },
    cleanFilters() {
      this.filter_ecommerce = {
        descricao: "",
        loja: "",
        categoria: "",
      };
      this.filter_marketplace = {
        descricao: "",
        loja: "",
        categoria: "",
      };
    },
    cleanProducts() {
      this.ecommerceProducts = [];
      this.marketplaceProducts = [];
    },
  },
});
